export const pushToDataLayer = (event) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  };
  
export function trackPageView({ page_id, page_name, page_type, user_login_state}) {
pushToDataLayer({
    event: "page_view",
    page_data: {
        page_id: page_id,
        page_name: page_name,
        page_type: page_type,
        site_brand: "Johnson's Baby",
        site_country: "br",
        site_franchise: "essential health",
        site_region: "LATAM",
        user_login_state: user_login_state
    },
    user_data: {}
});
};
